(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxOnDeviceConfigListItem(
    PrinterListPOSTPaging, $timeout, EventServiceEvents, OnDeviceConfigService
  ) {
    return {
      restrict: 'EA',
      scope: {
        onDeviceConfig: '=onDeviceConfig',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/printixGo/onDeviceConfigListItem/onDeviceConfigListItem.template.html',
      link: function(scope) {

        scope.pagedParams = new PrinterListPOSTPaging();
        scope.pageMetaData = new PrinterListPOSTPaging();

        (function() {
          scope.enableOnDevice = scope.tenant.info.enableOnDevice;
          getPrinterCount();
          setListeners();
        })();

        function getPrinterCount() {
          scope.pageMetaData.pagingCriteria.pageSize = 1;
          scope.onDeviceConfig.getPrinters(scope.pageMetaData).then(function(printerListObject) {
              scope.totalPrinters = printerListObject.page.totalElements;
            }, function(error) {
          }).catch(function(error) {});
        }

        scope.updateResources = function () {
          getPrinterCount();
        }

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Open contextueal dropdown
        ////////////////////////////////////
        scope.openonDeviceConfigMenu = function(event, onDeviceConfig) {
          scope.closeAllMenues();
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                {
                  title: 'DeleteGoConfiguration', selected: false, type: 'deleteSignInProfile', breaker: true,
                  disabled: (scope.totalPrinters > 0 ? true : (scope.enableOnDevice === 'SUSPENDED')) || scope.me.isSystemObserver()
                },
                {
                  title: 'Properties', selected: false, type: 'link', breaker: false, href: '/admin/#/goConfiguration/' + onDeviceConfig.id
                }
              ],
              context: onDeviceConfig,
              icon: 'icon-access-card-2',
              sizeClass: 'size125',
              type: 'ALLROUND'
            }
            scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Open context menu
        ////////////////////////////////////

        scope.closeAllMenues = function (selectedContextMenuItem, contextXPosition, contextContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextPosition = null;
          scope.contextContent = null;
          $timeout(function () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextPosition = contextXPosition;
            scope.context = contextContent;
            scope.auxiliaries = {
              tenant: scope.tenant,
              onDeviceConfig: scope.onDeviceConfig
            }
          }, 50)
        }

        function setListeners () {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_ONDEVICE_CONFIG_UPDATED, function (name, data) {
            if (data.onDeviceConfig === scope.onDeviceConfig.info._links.self.href) {
              OnDeviceConfigService.getOnDeviceConfigByUrl(data.onDeviceConfig).then(function(onDeviceConfig) {
                scope.onDeviceConfig = onDeviceConfig;
              }).catch(function(error) {});
            }
          })

        }

      }
    };
  }

  pxOnDeviceConfigListItem.$inject = ['PrinterListPOSTPaging', '$timeout', 'EventServiceEvents', 'OnDeviceConfigService'];

  angular
    .module('printix-admin')
    .directive('pxOnDeviceConfigListItem', pxOnDeviceConfigListItem);

})();
